export const iconFontAwesomeCommunicationWalkieTalkie = (
	<i className="fa-solid fa-walkie-talkie"></i>
);
